<script setup lang="ts">
import type { SightlineTeamCell } from "@/backend/natsstubs/sightline/models";

import SightlineTruncatedText from "./SightlineTruncatedText.vue";

defineProps<{ cell: SightlineTeamCell }>();
</script>

<template>
  <SightlineTruncatedText :text="cell.label" icon="persona/team" />
</template>
